import { Injectable } from '@angular/core';
import { ApiService, UserService } from '../../index';
@Injectable()
export class XuatChiSoService {
  APIURL = "api/ExcuteOracle";
  constructor(private apiService: ApiService, private userService: UserService) { }
  getChiSo(danhmucid, date, sotrang, sodong) {
    let curUser = this.userService.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_THONGSOVANHANH.P_LAY_DULIEU_PMAX_MIN_TB"}',
      "para": '{"v_Value":"' + danhmucid + '","V_DATE":"' + date + '","v_sotrang":"' + sotrang + '","v_sodong":"' + sodong + '","v_mataikhoan":"' + curUser.mataikhoan + '",}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }
  exportExcelChiSo(selectedCol, danhmucid, date, sotrang, sodong, tendonvi, tenchucnang, noidungbaocao) {
    let cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
      { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
    ];
   
    if (selectedCol.indexOf("pgiaomax") > -1) {
      cols.push({ "name": "importkw_max", "label": "P giao max", "horizontalalignment": "right" });
      cols.push({ "name": "tmax_importkw", "label": "Thời điểm P giao max", "horizontalalignment": "center" });
    }
    if (selectedCol.indexOf("pgiaotb") > -1) {
      cols.push({ "name": "importkw_avg", "label": "P giao trung bình", "horizontalalignment": "right" });
    }
    if (selectedCol.indexOf("pgiaomin") > -1) {
      cols.push({ "name": "importkw_min", "label": "P giao min", "horizontalalignment": "right" });
      cols.push({ "name": "tmin_importkw", "label": "Thời điểm P giao min", "horizontalalignment": "center" });
    }
    if (selectedCol.indexOf("pnhanmax") > -1) {
      cols.push({ "name": "exportkw_max", "label": "P nhận max", "horizontalalignment": "right" });
      cols.push({ "name": "tmax_exportkw", "label": "Thời điểm P nhận max", "horizontalalignment": "center" });
    }
    if (selectedCol.indexOf("pnhantb") > -1) {
      cols.push({ "name": "exportkw_avg", "label": "P nhận trung bình", "horizontalalignment": "right" });
    }
    if (selectedCol.indexOf("pnhanmin") > -1) {
      cols.push({ "name": "exportkw_min", "label": "P nhận min", "horizontalalignment": "right" });
      cols.push({ "name": "tmin_exportkw", "label": "Thời điểm P nhận min", "horizontalalignment": "center" });
    }
    let curUser = this.userService.getCurrentUser();
    let para: any = JSON.stringify({
      v_Value: danhmucid,
      V_DATE: date,
      v_sotrang: sotrang,
      v_sodong: sodong,
      v_mataikhoan:curUser.mataikhoan,
    });
    let config = JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAY_DULIEU_PMAX_MIN_TB" });
    return this.apiService.exportExcel("", cols, para, config, tendonvi, tenchucnang, noidungbaocao, date.replace("01/",""));
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/tien-ich/xuat-chi-so/xuatchiso.service.ts